import type React from "react";
import { useState, useEffect } from "react";
import styles from "../devotee.module.scss";
import commonStyles from "../../../App.module.scss";
import emptyDonationHistoryfrom from "../../../assets/emptyDonationHistory.svg";
import { Box, Card, FormControl, Typography } from "@mui/material";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import constants from "../../../config/constants.json";
import {
  getUserName,
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomMenuItem,
  CustomSelect,
  HcccCard,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import ToastComponent from "../../common/toastComponent";
import EmptyPage from "../../common/emptyPages/emptyPage";
import Pagination from "../../common/pagination/pagination";
import apiPath from "../../../config/apiPaths.json";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DonationHistoryResponseProps } from "../../../infrastructure/GlobalContextProvider";
import DonationReport from "../donationReport/DonationReport";
import { isNil } from "lodash";
import ToastError from "../../common/toast/toastError";
import ErrorPopup from "../../common/ErrorPopup";
import { CustomDownIcon, CustomUpIcon } from '../../common/StyledComponents/StyledFields';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
import { BeatLoader, BounceLoader, ClipLoader } from 'react-spinners';

export default function DonationHistory(): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [totalTanAmount, setTotalTanAmount] = useState<number>(0);
  const [donationHistoryData, setDonationHistoryData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const navigate = useNavigate();
  const [showyearEndReport, setShowYearEndReport] = useState<boolean>(false);
  const [selectedYear, setSelectedYear] = useState<string>("Donation Report");
  const [openYears, setOpenYears] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: apiPath.userDonationsHistory,
      params: {
        username: getUserName()?.toUpperCase(),
        sortBy: "dateofdonation",
        // page:pageNumber,
        // size:10,
        direction: "asc",
      },
      includeToken: true,
    })
      .then((res) => {
        setDonationHistoryData(res.data);
        setLoading(false);
        const totalAmount = res.data.reduce(
          (accumulator: number, yearData: any) => {
            const yearTotal = yearData.donationsInYear.reduce(
              (
                yearAccumulator: number,
                donation: DonationHistoryResponseProps
              ) => {
                return yearAccumulator + donation.amount;
              },
              0
            );

            return accumulator + yearTotal;
          },
          0
        );
        const totalTanAmount = res.data.reduce(
          (accumulator: number, yearData: any) => {
            const yearTanTotal = yearData.donationsInYear.reduce(
              (
                yearAccumulator: number,
                donation: DonationHistoryResponseProps
              ) => {
                return yearAccumulator + donation.tanAmount;
              },
              0
            );

            return accumulator + yearTanTotal;
          },
          0
        );
        setTotalAmount(
          totalAmount.toLocaleString("en-US", {
            maximumFractionDigits: 2,
            style: "currency",
            currency: "USD",
          })
        );
        setTotalTanAmount(
          totalTanAmount.toLocaleString("en-US", {
            maximumFractionDigits: 2,
            style: "currency",
            currency: "USD",
          })
        );
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
        setLoading(false);
      });
  }, [pageNumber]);

  const yearsList = [
    "2021",
    "2022",
    "2023",
    "Year End Report",
    "Donation Report",
  ];

  // useEffect(() => {
  //   const initialOpenYears: Record<string, boolean> = {};
  //   // Assuming yearsList contains all the years for which tables are rendered
  //   yearsList.forEach((year) => {
  //     initialOpenYears[year] = true;
  //   });
  //   setOpenYears(initialOpenYears);
  // }, []);

  const handleYearsDropdown = (value: any) => {
    setSelectedYear(value);
    if (value === "Donation Report") {
      setShowYearEndReport(false);
      // setSelectedYear("");
    } else {
      // setSelectedYear(value);
      setShowYearEndReport(true);
    }
  };

  const YearsDropDown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropdownStyle} sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          placeholder="Select Year"
          value={selectedYear}
          onChange={(e) => {
            handleYearsDropdown(e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {yearsList.map((item: string, index: number) => (
            <CustomMenuItem key={index} value={item}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {/* {errorMessage.nakshatram ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.nakshatram}
            </Typography>
          ) : (
            ""
          )} */}
      </FormControl>
    );
  };

  const donateButtonComponent = (): React.ReactElement => {
    return (
      <>
        <div className={styles.buttonContainer}>
          {/* {showyearEndReport ? <CommonOutlinedButton>Print</CommonOutlinedButton> : ""}
               {showyearEndReport ? <CommonOutlinedButton>Save</CommonOutlinedButton> : ""} */}
          {YearsDropDown()}
        </div>
      </>
    );
  };

  const nameAndButton = (): React.ReactElement => {
    return (
      <div className={styles.nameAndButton}>
        <p className={styles.heading}>Donation History</p>
        {donateButtonComponent()}
      </div>
    );
  };

  const donationHistoryFooter = (): React.ReactElement => {
    return (
      <div className={styles.totalDonationAmount}>
          <p className={styles.totalLabels}>Total Donation:</p>
          <p className={styles.totalLabels}>{totalAmount}</p>
          <p className={styles.totalLabels}>Total Tangible Donation:</p>
          <p className={styles.totalLabels}>{totalTanAmount}</p>
        </div>
    );
  };

  const handleDonateButton = (): void => {
    navigate("/donations");
  };

  const emptyPageButton = (): React.ReactElement => {
    return (
      <div>
        <CommonButton
          className={commonStyles.saveButton}
          onClick={handleDonateButton}
        >
          Donate Now
        </CommonButton>
      </div>
    );
  };

  const renderDateComponent = (): React.ReactElement => {
    return (
      <div className={styles.donationAndYearContainer}>
        {donationHistoryData?.map((data, index: number) => (
          <div key={index}>
            {SCMetingMinutesTableData(data.year, data.donationsInYear)}
          </div>
        ))}
      </div>
    );
  };

  const subContainer = (): React.ReactElement => {
    return (
      <Box>
        {nameAndButton()}
        {!showyearEndReport ? (
          renderDateComponent()
        ) : (
          <DonationReport year={selectedYear} />
        )}
        {!showyearEndReport ? donationHistoryFooter() : ""}
      </Box>
    );
  };

  const renderWithData = () => {
    return <>{subContainer()}</>;
  };

  const renderEmptyData = (): React.ReactElement => {
    return (
      <>
        <Typography className={styles.heading} sx={{ paddingTop: "20px" }}>
          Donation History
        </Typography>
        {loading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px",
            }}
          >
            <BounceLoader color="#22A699" loading={loading} size={45} />
            <span
              style={{
                marginLeft: "8px",
                fontSize: "15px",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Please wait...
            </span>
          </div>
        ) : (
          <EmptyPage
            imgUrl={emptyDonationHistoryfrom}
            subComponent={emptyPageButton()}
            typographyText="You have not donated"
          />
        )}

      </>
    );
  };

  const handleAccordionChange = (year: string) => {
    setOpenYears((prevOpenYears) => ({
      ...prevOpenYears,
      [year]: !prevOpenYears[year],
    }));
  };


  const SCMetingMinutesTableData = (
    year: string,
    dataList: DonationHistoryResponseProps[]
  ) => {

    let totalAmountForYear = 0;
    let totalTanAmountForYear = 0;

    // Calculate total amount for the current year
    dataList.forEach((item: DonationHistoryResponseProps) => {
      // Check if the donation entry is for the current year
      if (item.dateOfDonation.includes(year)) {
        // Add the amount for the current entry to the total amount for the year
        totalAmountForYear += item.amount;
        totalTanAmountForYear += item.tanAmount;
      }
    });
    return (
      <div style={{ marginBottom: "20px" }}>
        <div className={styles.year} onClick={() => handleAccordionChange(year)}>{year}<div style={{ marginLeft: "35px" }}>
          {openYears[year] ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )}</div>
        </div>
        {dataList?.length !== 0 ? (
          <div className={styles.donationtableContainer}>
            {openYears[year] ?
              <table className={styles.donationtableContainer}>
                <thead>
                  <tr className={styles.donationheaderTableRow}>
                    <th className={styles.donationtableHorizontal}>
                      Receipt No.
                    </th>
                    <th className={styles.donationtableHorizontal}>
                      Reference No.
                    </th>
                    <th className={styles.donationtableHorizontal}>
                      Date of Donation
                    </th>
                    <th className={styles.donationtableHorizontal}>
                      Mode of Payment
                    </th>
                    <th className={styles.donationtableHorizontal}>
                      Donation Purpose
                    </th>
                    <th className={styles.donationtableHorizontal} style={{ textAlign: "right" }}>Amount</th>
                    <th className={styles.donationtableHorizontal} style={{ textAlign: "right" }}>
                      Tangible Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataList?.map(
                    (item: DonationHistoryResponseProps, index: number) => (
                      <tr key={index} className={styles.donationtableRow}>
                        <td className={styles.donationtableDiagonal}>
                          {item.receiptNumber}
                        </td>
                        <td className={`${styles.donationtableDiagonal}`}>
                          {item.referenceNumber}
                        </td>
                        <td className={styles.donationtableDiagonal}>
                          {item.dateOfDonation}
                        </td>
                        <td className={styles.donationtableDiagonal}>
                          {item.donationType}
                        </td>
                        <td className={styles.donationtableDiagonal}>
                          {item.donationPurpose}
                        </td>
                        <td className={styles.donationtableDiagonal} style={{ textAlign: "right" }}>
                          {formatAmount(item.amount)}
                        </td>
                        <td className={styles.donationtableDiagonal} style={{ textAlign: "right" }}>
                          {formatAmount(item.tanAmount)}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>

              </table> : ""}
          </div>
        ) : (
          <div>No Data</div>
        )}
        <div className={styles.totalAmountByYear}>
          <p className={styles.totalLabel}>Total Amount:</p>
          <p className={styles.totalLabel}>{formatAmount(totalAmountForYear)}</p>
          <p className={styles.totalLabel}>Total Tangible Amount:</p>
          <p className={styles.totalLabel}>{formatAmount(totalTanAmountForYear)}</p>
        </div>
      </div>
    );
  };

  return (
    <HcccCard className={styles.DonationHistoryContainer}>
      <ToastComponent />
      {donationHistoryData?.length === 0 ? renderEmptyData() : renderWithData()}
      {totalRecords > 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "10px",
          }}
        >
          <Pagination
            items={totalRecords}
            itemsPerPage={10}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      ) : (
        ""
      )}
    </HcccCard>
  );
}
